(function() {
  'use strict';

  // i18n() is a no-op marker so the extraction script can find these keys.
  function i18n(key) { return key; }

  var EVENT_STATES = {
    DRAFT: {
      id: 'draft',
      title: i18n('Draft'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    FAILED: {
      id: 'failed',
      title: i18n('Action failed'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    ACCEPTED: {
      id: 'accepted',
      title: i18n('Accepted'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    REJECTED: {
      id: 'rejected',
      title: i18n('Rejected'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    COMPLETE: {
      id: 'complete',
      title: i18n('Complete'),
      labelStyle: 'success',
      borderStyle: 'complete'
    },
    OBSOLETE: {
      id: 'obsolete',
      title: i18n('Obsolete'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    MERGED: {
      id: 'merged',
      title: i18n('Merged'),
      labelStyle: 'success',
      borderStyle: 'success'
    },
    PENDING: {
      id: 'pending',
      title: i18n('Pending'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    PROCESSING: {
      id: 'processing',
      title: i18n('Processing'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    PENDING_APPROVAL: {
      id: 'pending_approval',
      title: i18n('Waiting for approval'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    SUBMITTED: {
      id: 'submitted',
      title: i18n('Submitted'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    PARTIAL: {
      id: 'partial',
      title: i18n('Awaiting responses'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    RETRACTED: {
      id: 'retracted',
      title: i18n('Retracted'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    INPROGRESS: {
      id: 'inProgress',
      title: i18n('In progress'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    } // used for goals

  };

  var EVENT_ALLOWED_STATES = {
    rePublish: [],
    reRequest: [EVENT_STATES.SUBMITTED.id, EVENT_STATES.PARTIAL.id],
    accept: [EVENT_STATES.SUBMITTED.id, EVENT_STATES.FAILED.id],
    close: [EVENT_STATES.PARTIAL.id],
    invite: [EVENT_STATES.SUBMITTED.id, EVENT_STATES.PARTIAL.id],
    reject: [EVENT_STATES.PARTIAL.id, EVENT_STATES.SUBMITTED.id, EVENT_STATES.DRAFT.id],
    retract: [EVENT_STATES.SUBMITTED.id],
    delete: [EVENT_STATES.DRAFT.id, EVENT_STATES.RETRACTED.id],
    edit: [
      EVENT_STATES.PARTIAL.id,
      EVENT_STATES.DRAFT.id,
      EVENT_STATES.INPROGRESS.id,
      EVENT_STATES.FAILED.id,
      EVENT_STATES.REJECTED.id,
      EVENT_STATES.ACCEPTED.id,
      EVENT_STATES.SUBMITTED.id
    ],
    changeVisibility: [
      EVENT_STATES.FAILED.id,
      EVENT_STATES.SUBMITTED.id,
      EVENT_STATES.PARTIAL.id,
      EVENT_STATES.REJECTED.id,
      EVENT_STATES.RETRACTED.id,
      EVENT_STATES.COMPLETE.id,
      EVENT_STATES.INPROGRESS.id
    ]
  };

  var EVENT_STATES_ORDERED = ['draft', 'submitted', 'partial', 'complete', 'rejected'];

  var INVITEES_STATES = {
    draft: { id: 'draft', name: i18n('Waiting'), style: 'warning' },
    pending: {
      id: 'pending',
      name: i18n('Waiting For Approval'),
      style: 'warning'
    },
    importedManually: { id: 'importedManually', name: i18n('Manually Imported'), style: 'success' },
    respondedElectronically: {
      id: 'respondedElectronically',
      name: i18n('Responded'),
      style: 'success'
    },
    rejected: { id: 'rejected', name: i18n('Rejected'), style: 'danger' }
  };

  angular.module('component.events')
    .constant('EVENT_STATES', EVENT_STATES)
    .constant('EVENT_STATES_ORDERED', EVENT_STATES_ORDERED)
    .constant('EVENT_ALLOWED_STATES', EVENT_ALLOWED_STATES)
    .constant('INVITEES_STATES', INVITEES_STATES);
})();
